<template>
    <div class="groupgrouping spackage padding-20 bgc box-shadow" v-loading="loading">
        <section class="gc-header">
            <el-button type="primary" align="left" @click="createGG">新增分组</el-button>
            <div align="right" style="float:right">
                <el-input placeholder="请输入分组名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="searchGroupList()" plain>搜索</el-button>
            </div>
        </section>

        <section>
            <el-table :data="tableData" header-row-class-name="tableHead">
                <el-table-column prop="index" label="序号" align="left" width="100"> </el-table-column>
                <el-table-column prop="name" label="分组名称" align="center"></el-table-column>
                <el-table-column prop="commcount" label="群数量" align="center"></el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="200"></el-table-column>
                <el-table-column prop="memo" label="分组说明" align="center"></el-table-column>
                <el-table-column label="操作" align="right" width="150">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button @click="editGG(scope.row.innerid)">编辑</el-button>
                            <span>|</span>
                            <el-button @click="deleteGG(scope.row.innerid)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <!-- 编辑分组 弹窗 -- start -->
        <el-dialog :title="isEdit ? '编辑分组' : '新增分组'" :visible.sync="dialogFormVisible" @close="cancelCE" class="create_edit_dialog">
            <el-form :model="ggFormData" :rules="rules" ref="ggFormData">
                <el-form-item label="分组名称" :label-width="formLabelWidth" prop="name">
                    <el-input type="text" v-model="ggFormData.name" minLength="1" maxLength="8" autocomplete="off" placeholder="输入分组名称，不超过8个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="分组说明" :label-width="formLabelWidth" prop="memo">
                    <el-input type="textarea" :rows="4" v-model="ggFormData.memo" maxLength="80" autocomplete="off" placeholder="输入分组说明，不超过80个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelCE">取 消</el-button>
                <el-button type="primary" @click="sureAdd(currentid ? currentid : '')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑分组 弹窗 -- end -->

        <!-- 删除 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">确定要删除该分组？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteGroup(currentid)">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -- 弹窗 -- end -->

        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->
    </div>
</template>

<script>
import {getCommGroupList, saveOrUpdateCommGroup, getCommGroupInfo, updateCommGroupByStatus} from '@/api/cPurchaseApi'
import {getCookie} from '@/common/js/tools'
import {mapActions} from 'vuex'
// import Page from 'base/page/page'
import $ from 'jquery'

export default {
    name: 'groupGrouping',
    data() {
        return {
            form: {},
            loading: false,
            token: getCookie('token'),
            sessionUser: JSON.parse(sessionStorage['user']),
            shopID: JSON.parse(sessionStorage['shop']).ShopID,
            selectValue: '',
            nameInput: '',
            currentPage: 1,
            rowCount: 0, // 数据条数
            page: 1, // 页数
            apiData: {}, // 查询/分页 api 数据
            tableData: [], // 商品分类table数据
            dialogFormVisible: false,
            formLabelWidth: '80px',
            deleteDialog: false,
            rules: {
                name: [
                    {required: true, message: '请输入分组名称', trigger: 'blur'}
                ]
            },
            ggFormData: {
                name: '',
                memeo: ''
            },
            isEdit: false,
            currentid: '',
            searchName: ''
        }
    },
    mounted() {
        this.setLoading(true)
        this.getGroupList(1, '')
    },
    methods: {
        // 新增分组 按钮
        createGG() {
            this.isEdit = false
            this.currentid = ''
            // this.ggFormData.name = ''
            // this.ggFormData.memo = ''
            this.dialogFormVisible = true
        },

        // 取消编辑或创建
        cancelCE() {
            this.dialogFormVisible = false
            this.ggFormData.name = ''
            this.ggFormData.memo = ''
        },

        // 新增分组 接口调用
        sureAdd(id) {
            this.setLoading(true)
            let data = {
                innerid: id,
                name: this.ggFormData.name,
                memo: this.ggFormData.memo
            }
            saveOrUpdateCommGroup({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.dialogFormVisible = false
                    this.ggFormData.name = ''
                    this.ggFormData.memo = ''
                    this.$message.success('保存分组成功')
                    this.getGroupList(1, this.searchName ? this.searchName : '')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 编辑分组
        editGG(id) {
            this.isEdit = true
            this.dialogFormVisible = true
            this.currentid = id
            let data = {
                innerid: id
            }
            getCommGroupInfo({
                data: data,
                success: data => {
                    this.ggFormData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 删除
        deleteGG(id) {
            this.deleteDialog = true
            this.currentid = id
        },

        // 删除分组 接口调用
        deleteGroup(id) {
            let data = {
                innerid: id
            }
            this.setLoading(true)
            updateCommGroupByStatus({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.deleteDialog = false
                    this.$message.success('删除分组成功')
                    this.getGroupList(1, this.searchName ? this.searchName : '')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 获取分组列表
        getGroupList(page, name) {
            let data = {
                name: name,
                page: page,
                pageSize: 10
            }
            this.setLoading(true)
            getCommGroupList({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 搜索
        searchGroupList() {
            this.setLoading(true)
            this.getGroupList(1, this.searchName)
        },

        // 分页加载
        fPage() {
            this.setLoading(true)
            let clickPage = $('.el-pagination .active').html()
            this.getGroupList(clickPage, this.searchName ? this.searchName : '')
        },

        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .tableHead {
        font-weight: bold;
    }
    .groupgrouping {
        .create_edit_dialog {
            .el-dialog {
                width: 550px;
                height: 350px;
            }
            .el-dialog__body {
                padding: 20px 20px 0 20px;
            }
            .el-dialog__footer {
                padding: unset;
            }
            .el-input {
                width: 420px;
            }
        }
        .dele_dialog {
            .el-dialog__body {
                text-align: center;
            }
        }
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .el-textarea textarea {
            width: 420px;
            height: 130px;
            resize: none;
        }
        .gc-header {
            height: 40px;
            margin-bottom: 30px;
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }

        .table-title {
            img {
                width: 106px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
        }
    }
</style>
